{
  "serie": {
    "display": "Afficher le diagramme",
    "hide": "Masquer le diagramme",
    "remove": "Retirer le diagramme",
    "displaySettings": "Afficher les paramétrages du diagramme",
    "selectColor": "Cliquer pour sélectionner une couleur",
    "color": "Couleur",
    "type": "Type",
    "types": {
      "line": "Ligne",
      "bar": "Barre"
    }
  }
}
